module.exports = Package["meteor"];